import UpgradeAccountError from './UpgradeAccountError';
class InvestorDoesNotHavePendingCorrections extends UpgradeAccountError {
    constructor(options) {
        super('Investor does not have pending corrections', options);
    }
}
export default InvestorDoesNotHavePendingCorrections;
